import {
  UPDATE_SESSION
} from '@actions/types';

const INITIAL_STATE = {
  logged_in: false,
  has_check_authorized: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_SESSION:
      return { ...state, logged_in: action.payload, has_check_authorized: true };
    default:
      return state;
  }
};
